module.exports = __webpack_public_path__ + "static/img/our-awards_8.350bab3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/our-awards_8.png
// module id = Flmj
// module chunks = 0